import React from "react";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import LaunchIcon from "@material-ui/icons/Launch";
import moment from "moment";

const AddPickups = ({
  handleSubmit,
  handleCheckAll,
  handleDeliveries,
  handleAddPickups,
  stateDeliveries,
  stateMerchants,
  merchants,
  deliveries,
  driver_id,
}) => {
  return (
    <Accordion>
      <Form onSubmit={handleSubmit}>
        {merchants.map((merch, i) => {
          const merchantDeliveries = deliveries.filter(
            (del) => merch.shipfrom_name == del.shipfrom_name
          );
          return (
            <Card key={i}>
              <Accordion.Toggle
                as={Button}
                variant="outline-success"
                eventKey={`${merch.shipfrom_name}`}
              >
                <Form.Check
                  type="checkbox"
                  name={merch.shipfrom_name}
                  checked={stateMerchants[merch.shipfrom_name] || false}
                  onChange={handleCheckAll}
                  label={`${merch.merchant_id} - ${merch.shipfrom_name}`}
                />
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={`${merch.shipfrom_name}`}>
                <Card.Body style={{ padding: 0 }}>
                  <Table striped bordered hover responsive>
                    <tbody>
                      {merchantDeliveries.map((del) => (
                        <tr
                          style={{ width: "100%" }}
                          key={del.id}
                          className={del.date ? "table-primary" : "table-info"}
                        >
                          <td>
                            <Form.Check
                              type="checkbox"
                              name={del.id}
                              checked={stateDeliveries[del.id] || false}
                              onChange={handleDeliveries}
                              label={`Order ${del.order_number}`}
                            />
                          </td>
                          <td>
                            <Link
                              to={`/fulfillments/${del.order_id}`}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <LaunchIcon />
                            </Link>
                          </td>
                          <td>
                            {del.shipto_first_name} {del.shipto_last_name}{" "}
                          </td>
                          <td>
                            {del.date && moment(del.date).format("MMM DD")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
        <div className="container-fluid text-center">
          <h4>Add pickup tasks to the route</h4>
          {!driver_id && (
            <h6 className="text-danger">
              Assign driver for the route and refresh the page to confirm
            </h6>
          )}
          <Button
            variant="primary"
            disabled={!driver_id}
            onClick={handleAddPickups}
          >
            Confirm
          </Button>
        </div>
      </Form>
    </Accordion>
  );
};

export default AddPickups;
